{
  "name": "Mushroom Popper Button",
  "powerupName": "MushroomPopper",
  "levelUpDescriptions": [
    "MushroomPopperUpgradeDescription1",
    "MushroomPopperUpgradeDescription2",
    "MushroomPopperUpgradeDescription3",
    "MushroomPopperUpgradeDescription4",
    "MushroomPopperUpgradeDescription5"
  ]
}